// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"230":"component---src-pages-index-jsx","883":"component---src-pages-404-js"}[chunkId] + "-" + {"230":"6e088739e87a118ce7ab","883":"3cf1cf296854c8578fa4"}[chunkId] + ".js";
};